// extracted by mini-css-extract-plugin
module.exports = {"ArticlesOthers":"ArticlesOthers_ArticlesOthers__2W129","ArticlesOthers__item":"ArticlesOthers_ArticlesOthers__item__kCMHp"};